import { api } from "roboflex-thalamus-request-handler";

export default {
  async listar() {
    const response = await api.get("root/empresas");
    return response.data;
  },
  async buscar(id) {
    const response = await api.get(`root/empresas/${id}`);
    return response.data;
  },
  async criar(payload) {
    const response = await api.post("root/empresas", payload);
    return response.data;
  },
  async atualizar(id, payload) {
    const response = await api.put(`root/empresas/${id}`, payload);
    return response.data;
  },
  async excluir(id) {
    const response = await api.delete(`root/empresas/${id}`);
    return response.data;
  },
  async listarUsuarios(empresaId) {
    const response = await api.get(`root/empresas/${empresaId}/usuarios`);
    return response.data;
  },
  async criarUsuario(empresaId, payload) {
    const response = await api.post(`root/empresas/${empresaId}/usuarios`, payload);
    return response.data;
  },
  async listarGrupos(empresaId) {
    const response = await api.get(`root/empresas/${empresaId}/grupos`);
    return response.data;
  },
  async criarGrupo(empresaId, payload) {
    const response = await api.post(`root/empresas/${empresaId}/grupos`, payload);
    return response.data;
  },
  async syncGrupoFuncionalidades(empresaId, grupoId, funcionalidadeIds) {
    const response = await api.put(
      `root/empresas/${empresaId}/grupos/${grupoId}/funcionalidades`,
      { funcionalidade_ids: funcionalidadeIds }
    );
    return response.data;
  },
  async syncGrupoUsuarios(empresaId, grupoId, userIds) {
    const response = await api.put(
      `root/empresas/${empresaId}/grupos/${grupoId}/usuarios`,
      { user_ids: userIds }
    );
    return response.data;
  },
  async listarFuncionalidades() {
    const response = await api.get("root/funcionalidades");
    return response.data;
  },
  async criarFuncionalidade(payload) {
    const response = await api.post("root/funcionalidades", payload);
    return response.data;
  },
  async atualizarFuncionalidade(id, payload) {
    const response = await api.put(`root/funcionalidades/${id}`, payload);
    return response.data;
  },
};
